import React from 'react'

export default function Svg (props) {
  return (
    <>
      {props.svg !== '' && <div className='svg-div' dangerouslySetInnerHTML={{ __html: props.svg }} />}
    </>
  )
}
